import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, IconButton, Tooltip } from '@mui/material';

import type { CompetitorProperty } from '~/types/services/priceParrot';

interface Props {
  property: CompetitorProperty;
  iconOnly?: boolean;
}

const LABEL = 'Open their offer';

// No referrer, so the competitor can't tell the visit came from our admin.
export default function CompetitorOfferSiteLink({ property, iconOnly = false }: Props) {
  if (!property.dealUrl) {
    return null;
  }
  const linkProps = {
    href: property.dealUrl,
    target: '_blank',
    rel: 'noopener noreferrer',
    referrerPolicy: 'no-referrer',
  } as const;
  if (iconOnly) {
    return (
      <Tooltip title={LABEL}>
        <IconButton size="small" aria-label={LABEL} {...linkProps}>
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Button size="small" endIcon={<OpenInNewIcon fontSize="small" />} {...linkProps}>
      {LABEL}
    </Button>
  );
}
